export default __webpack_public_path__ + "static/media/home_web-sm@1x.a69dd2e9.jpg";